import i18next from 'i18next';

import { data as enums } from '~constants/enums';
import { useStores } from '~store';

const createFormatter = (options?: Intl.NumberFormatOptions) => {
  return new Intl.NumberFormat(i18next.language, options);
};

export const makeCurrencyFormatter =
  (currency?: string | null) =>
  (value: number | string, options?: Intl.NumberFormatOptions) => {
    return createFormatter({
      style: 'currency',
      currency: currency || enums.currency.default,
      ...options,
    }).format(value as number);
  };

export const useCompanyCurrency = () => {
  const { userStore } = useStores();
  const { currency } = userStore.userCompany;

  return {
    currencyFormatter: makeCurrencyFormatter(currency),
  } as const;
};
